import IconReusable from "../../components/IconReusable";
import { MODULE_PERMISSION_ENUM } from "../Sidebar/Enum";

export const getTabConfig = (isPwa, menuLabelMap, tokenData) => [
  {
    label: menuLabelMap?.home || "Home",
    path: isPwa ? "/pwa-main-menu" : "/",
    inactiveIcon: <IconReusable name="HomeOutlined" size={24} />,
    activeIcon: <IconReusable name="HomeFilled" size={24} />,
    key: MODULE_PERMISSION_ENUM.HOME,
    visible: true,
  },
  {
    label: menuLabelMap?.my_business || "My Business",
    path: "/my-business",
    inactiveIcon: <IconReusable name="BusinessOutlined" size={24} />,
    activeIcon: <IconReusable name="BusinessFilled" size={24} />,
    key: MODULE_PERMISSION_ENUM.MY_BUSINESS,
    visible: !tokenData?.sfa,
  },
  {
    label: menuLabelMap?.my_network || "My Network",
    path: "/my-network",
    inactiveIcon: <IconReusable name="Network" size={24} />,
    activeIcon: <IconReusable name="NetworkFilled" size={24} />,
    key: MODULE_PERMISSION_ENUM.MY_NETWORK,
    visible: !tokenData?.sfa,
  },
  {
    label: menuLabelMap?.my_benefits || "Benefits",
    path: "/benefits/mybenefits",
    inactiveIcon: <IconReusable name="BenefitsOutlined" size={24} />,
    activeIcon: <IconReusable name="BenefitsOutlined" size={24} />,
    key: MODULE_PERMISSION_ENUM.MY_BENEFITS,
    visible: !tokenData?.sfa,
  },
  {
    label: menuLabelMap?.performance || "Performance",
    path: "/my-performance/network-performance",
    inactiveIcon: <IconReusable name="PerformanceOutlined" size={24} />,
    activeIcon: <IconReusable name="PerformanceOutlined" size={24} />,
    key: MODULE_PERMISSION_ENUM.NETWORK_PERFORMANCE,
    visible: !tokenData?.sfa,
  },
  {
    label: menuLabelMap?.payment || "Payment",
    path: "/payment",
    inactiveIcon: <IconReusable name="PaymentOutlined" size={24} />,
    activeIcon: <IconReusable name="PaymentOutlined" size={24} />,
    key: MODULE_PERMISSION_ENUM.PAYMENT,
    visible: !tokenData?.sfa,
  },
];
